import styled from "styled-components";

export const Wrapper = styled.div`
  .graph-column-container,
  .Data-column-container {
    border-bottom: 2px solid #e7d8d8;
    border-radius: 5px;
  }
  .Pay-history-column-container {
    padding-left: 20px !important;
    h5 {
      margin: 0px;
    }
  }
  .graph-column-container {
    padding-bottom: 50px;
  }
  .amount-container {
    display: flex;
    justify-content: end;
  }
  .data-row {
    padding: 0px 11px;
    h5 {
      font-size: 17px;
    }
  }
  .ant-collapse {
    border: none;
  }
  .ant-collapse-item {
    border-bottom: none;
  }
  .ant-collapse-content {
    border-top: none;
    border: 2px solid #e7d8d8;
    margin: 5px 10px 5px 10px;
  }
  .ant-collapse-header {
    background: #3a96b8;
    color: white;
    margin-bottom: 5px !important;
  }
  .ant-collapse-expand-icon {
    height: 54px;
    display: flex;
    align-items: center;
    color: white;
  }
  .collapse-ruppee-header {
    font-size: 17px;
    font-weight: bold;
    color: white;
  }
  .collapse-date-header {
    font-size: 15px;
    font-weight: 550;
    color: white;
  }

  .sub-collapse-row {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sub-collapse-name {
    padding-left: 11px;
    p {
      margin: 0px;
    }
  }
  .sub-collapse-ruppee {
    display: flex;
    justify-content: center;
    p {
      margin: 0px;
    }
  }
  .sub-collapse-description {
    display: flex;
    justify-content: flex-end;
    padding-right: 11px;
    p {
      margin: 0px;
    }
  }
`;
